import React, { useContext } from 'react';

import {
  ListSubheader,
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import {
  AccountCircle,
  Category,
  LocalOffer,
  Stars,
  TextIncrease,
  Inventory,
  ListAlt,
  PersonPin,
  CardGiftcard,
  LocationOn
} from '@mui/icons-material';
// import { CheckmarkIcon } from 'react-hot-toast';

// Generate the menu for the Admin List

interface RouterParams {
  to: string;
  icon: React.FC;
  label: string;
}

const AdminMenus: RouterParams[] = [
  {
    to: 'product',
    label: 'Product',
    icon: Category
  },
  {
    to: 'product-variants',
    label: 'Variants',
    icon: Inventory
  },
  {
    to: 'attributes',
    label: 'Attributes',
    icon: TextIncrease
  },
  {
    to: 'brands',
    label: 'Brands',
    icon: Stars
  },
  {
    to: 'tags',
    label: 'Tags',
    icon: LocalOffer
  },
  {
    to: 'staff-account',
    label: 'Staff Account',
    icon: AccountCircle
  },

  {
    to: 'orders',
    label: 'Orders',
    icon: ListAlt
  }
  , {
    to: 'discount-management',
    label: 'Discounts',
    icon: LocationOn
  }, {
    to: 'referral',
    icon: LocationOn,
    label: 'Referral'
  }, {
    to: 'referral-usage',
    icon: ListAlt,
    label: 'Referral Usage'
  }, {
    to: 'referral-payouts',
    icon: ListAlt,
    label: 'Referral Payout'
  }
  , {
    to: 'order-admin',
    label: 'Create Order',
    icon: TableChartTwoToneIcon
  },
  {
    to: 'sellers',
    label: 'Sellers',
    icon: PersonPin
  },
  {
    to: 'perks',
    label: 'Perks',
    icon: CardGiftcard
  },
  {
    to: 'scrapper',
    label: 'E-Commerce Scrapper',
    icon: ListAlt
  }
];

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.trueWhite[50]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
            color: ${theme.colors.alpha.trueWhite[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
    'transform',
    'opacity'
  ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);

  return (
    <>
      <MenuWrapper>
        <List
          component="div"
          subheader={
            <ListSubheader component="div" disableSticky>
              Management
            </ListSubheader>
          }
        >
          <SubMenuWrapper>
            <List component="div">
              {AdminMenus.map((menu, index) => (
                <ListItem component="div" key={index}>
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={menu.to}
                    startIcon={<menu.icon />}
                  >
                    {menu.label}
                  </Button>
                </ListItem>
              ))}
            </List>
          </SubMenuWrapper>
        </List>
      </MenuWrapper>
    </>
  );
}

export default SidebarMenu;
